// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"c7a95904","251":"76f8d455","348":"0bb70bc9","364":"28e85af7","571":"d2a95835"}[chunkId] + ".chunk.js";
};